import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting/routes_names';
import USER_PERMISSIONS from '@/utils/constants/accounting/permissions_aliases';

const actions = [
    {
        routeName: ROUTES.AP_INVOICES.name,
        items: [
            {
                title: 'add invoice',
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_NEW_INVOICE);
                },
                routeName: ROUTES.AP_INVOICES_ADD_NEW.name,
            },
            {
                title: 'import invoice',
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_IMPORT_INVOICES);
                },
                routeName: ROUTES.AP_INVOICES_IMPORT.name,
            },
            {
                title: 'make a refund to the resident',
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_NEW_INVOICE);
                },
                routeName: ROUTES.AP_INVOICES_ADD_REFUND_TO_RESIDENT.name,
            },
            {
                title: 'payments to investors',
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_NEW_INVOICE);
                },
                routeName: ROUTES.AP_INVOICES_ADD_PAYMENTS_TO_INVESTORS.name,
            },
            {
                title: 'view planned future invoices',
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_VIEW_INVOICES);
                },
                routeName: ROUTES.AP_INVOICES_FUTURE.name,
            },
        ],
    },
];

export default actions;
